import { AnnualReportSigningStepsActionTypes } from "models/actionTypes/annualReportSigningStepsActionTypes";
import { ReduxConstants } from "utils/constants";

export const annualReportSigned = (id: number): AnnualReportSigningStepsActionTypes => {
  return {
    type: ReduxConstants.AnnualReportSigningStepsActions.ANNUAL_REPORT_STEP_SIGNED,
    payload: id,
  };
};
